/**
 * « Un chien vient de partir avec le produit. » Le hotspot est neutralisé
 * temporairement puis rendu, sans jamais bloquer la navigation.
 */
export interface Theft {
  cancel(): void;
  restore(): void;
}

export function stealHotspot(
  button: HTMLButtonElement | undefined,
  durationMs: number,
  onRestore?: () => void,
): Theft | null {
  if (!button || button.disabled) return null;

  const previousState = button.dataset['state'] ?? 'normal';
  button.disabled = true;
  button.dataset['state'] = 'disabled';
  button.classList.add('is-stolen');

  let timer: number | undefined;

  const restore = (): void => {
    if (timer !== undefined) window.clearTimeout(timer);
    timer = undefined;
    button.disabled = false;
    button.dataset['state'] = previousState;
    button.classList.remove('is-stolen');
    onRestore?.();
  };

  timer = window.setTimeout(restore, durationMs);

  return {
    restore,
    cancel(): void {
      if (timer !== undefined) window.clearTimeout(timer);
      timer = undefined;
    },
  };
}

export interface ChainStep {
  hotspotId: string;
  /** Classe d'animation appliquée à l'élément, retirée à la fin. */
  animation: 'is-shaking' | 'is-falling' | 'is-swinging';
  delayMs: number;
}

/**
 * Réaction en chaîne : plusieurs objets réagissent l'un après l'autre.
 * Chaque animation se retire toute seule pour pouvoir être rejouée.
 */
export function playChain(
  elements: Map<string, HTMLButtonElement>,
  steps: ChainStep[],
  onDone?: () => void,
): void {
  let elapsed = 0;
  for (const step of steps) {
    elapsed += step.delayMs;
    window.setTimeout(() => {
      const element = elements.get(step.hotspotId);
      if (!element) return;
      element.classList.remove(step.animation);
      void element.offsetWidth;
      element.classList.add(step.animation);
      window.setTimeout(() => element.classList.remove(step.animation), 900);
    }, elapsed);
  }
  if (onDone) window.setTimeout(onDone, elapsed + 400);
}
